<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							New Withdraw Request - 
							<span style="font-weight: bold;">Total Credit: <span class="badge badge-16 badge-primary">{{agentCommission.commission_amount}}</span>
								Last Updated: <span class="badge badge-16 badge-info">{{agentCommission.last_updated}}</span>
							</span> 
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								   <div class="col-md-6">
									   <label for="paymentSelect" class="col-form-label">Bank Info <span class="text-danger">*</span></label>
									   <select v-model="withdrawRequest.agent_bank_id" @blur="validationRule()" class="form-control" id="paymentSelect">
										   <option value="">Select Bank</option>
										   <option v-for="bank in bankList" :key="bank.id" :value="bank.id">{{ bank.name }} - {{ bank.account_number }} - {{ bank.payment_method.name }}</option>
									   </select>
									   <small class="text-danger">{{validationData.agent_bank_id}}</small>
								   </div>
								   <div class="col-md-6">
									   <label for="inputAmount" class="col-form-label">Amount <span class="text-danger">*</span></label>
									   <input type="number" v-model="withdrawRequest.amount" @blur="validationRule()" class="form-control" id="inputAmount">
									   <small class="text-danger">{{validationData.amount}}</small>
								   </div>
							</div>

							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'depositCreate',
		metaInfo: {
            title: "Deposit Create",
            titleTemplate: "%s ← BXB",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				bankList: [],
				message: "",
				agentCommission: [],
				withdrawRequest: {
					agent_bank_id: "",
					amount: ""
				},
				validationData: {
					agent_bank_id: "",
					amount: ""
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				getAgentCommissionAction: 'getAgentCommissionAction',
				agentRequestWithdrawAction: 'agentRequestWithdrawAction',
				getAgentBanks: 'getAgentBanks',
			}),
			async getAgentCommission(){
				await this.getAgentCommissionAction().then(res => {
					this.agentCommission = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getBanks(){
				await this.getAgentBanks().then(res => {
					this.bankList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
				
				const formData = new FormData();
				formData.append('agent_bank_id', this.withdrawRequest.agent_bank_id);
				formData.append('amount', this.withdrawRequest.amount);

				await this.agentRequestWithdrawAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: 'agent-request-withdraw-list', 
					query: {
						page: 1, 
						orderBy: 'desc', 
						sortKey: 'created_at',
						status: '',
                        agent_bank_id: '',
                        from: '',
                        to: ''
					}
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.withdrawRequest.agent_bank_id == "") {
					this.validationData.agent_bank_id = "The payment method field is required."
					isValidation.push(true)
				} else {
					this.validationData.agent_bank_id = ""
					isValidation.push(false)
				}
				if (this.withdrawRequest.amount == "") {
					this.validationData.amount = "The amount field is required."
					isValidation.push(true)
				} else {
					this.validationData.amount = ""
					isValidation.push(false)
				}

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
			await this.getBanks()
			await this.getAgentCommission()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>